/**
 * Demo Credentials EXAMPLE - committed to git as the template.
 *
 * To use the demo login UI locally:
 *   1. Copy this file to src/config/demoCredentials.js
 *   2. Replace 'REPLACE_WITH_LOCAL_PASSWORD' with actual local test passwords
 *   3. demoCredentials.js is gitignored and must never be committed
 *
 * Local passwords for beta testers are distributed out-of-band by Philippe.
 */

/**
 * Demo Credentials - Development Only
 *
 * These credentials exist ONLY for local development and demo purposes.
 * In production (Sprint 4+), authentication is handled by Supabase Auth.
 *
 * NEVER use these credentials in production. They are automatically
 * excluded when REACT_APP_ENV === 'production'.
 */

const USER_ROLES = {
    ADMIN: 'admin',
    MANAGEMENT: 'management',
    BOARD: 'board',
    MEMBER: 'member'
};

// All entries below use real Supabase Auth accounts.
// Passwords are local-only and must be filled in after copying this template.
const DEMO_USERS = [
    {
        id: '385ae5e5-d6a4-4cb9-a626-05bb03274ef1',
        email: 'phil.f.villard@gmail.com',
        password: 'REPLACE_WITH_LOCAL_PASSWORD',
        roles: [USER_ROLES.ADMIN, USER_ROLES.BOARD, USER_ROLES.MEMBER],
        portalRole: USER_ROLES.ADMIN,
        name: 'Philippe Villard',
        phone: '(406) 555-0100'
    },
    {
        id: '38a2ab29-4244-4663-92f1-1b9362726308',
        email: 'rcn693@gmail.com',
        password: 'REPLACE_WITH_LOCAL_PASSWORD',
        roles: [USER_ROLES.BOARD, USER_ROLES.MEMBER],
        portalRole: USER_ROLES.BOARD,
        name: 'Rick Nielsen',
        phone: '(406) 555-0102'
    },
    {
        id: 'ff2fda9b-e1d8-4915-8086-82b6478e5e61',
        email: 'ericorganic@gmail.com',
        password: 'REPLACE_WITH_LOCAL_PASSWORD',
        roles: [USER_ROLES.BOARD, USER_ROLES.MEMBER],
        portalRole: USER_ROLES.BOARD,
        name: 'Eric Newman',
        phone: '(406) 555-0104'
    },
    {
        id: '4f6f31ba-a309-4188-aef3-82b204812fd1',
        email: 'prestigerem@gmail.com',
        password: 'REPLACE_WITH_LOCAL_PASSWORD',
        roles: [USER_ROLES.MANAGEMENT],
        portalRole: USER_ROLES.MANAGEMENT,
        name: 'Denise Lafaver',
        phone: '(406) 752-4853'
    },
    {
        id: 'd4132fc9-0e1c-4ede-8fb2-0a4efaea7db3',
        email: 'angarimp@gmail.com',
        password: 'REPLACE_WITH_LOCAL_PASSWORD',
        roles: [USER_ROLES.MEMBER],
        portalRole: USER_ROLES.MEMBER,
        name: 'Maria Paula Angarita',
        phone: '(406) 555-0105'
    },
    {
        id: '0fe3ee86-53ea-417e-9e76-1eafe16dd288',
        email: 'oraresemper@gmail.com',
        password: 'REPLACE_WITH_LOCAL_PASSWORD',
        roles: [USER_ROLES.MEMBER],
        portalRole: USER_ROLES.MEMBER,
        name: 'Steve Michels',
        phone: '(406) 555-0106'
    },
];

/**
 * Returns demo users for development/demo mode only.
 * Returns empty array in production to force Supabase Auth.
 */
export const getDemoUsers = () => {
    if (process.env.REACT_APP_ENV === 'production') {
        return [];
    }
    return DEMO_USERS;
};

/**
 * Demo credential hints shown in the login UI for quick access.
 * Only visible in non-production environments.
 */
export const getDemoCredentialHints = () => {
    if (process.env.REACT_APP_ENV === 'production') {
        return [];
    }
    return [
        { role: 'Administrator (Philippe)', email: 'phil.f.villard@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-amber-700' },
        { role: 'Management (Denise)', email: 'prestigerem@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-forest-700' },
        { role: 'Board (Rick)', email: 'rcn693@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-forest-700' },
        { role: 'Board (Eric)', email: 'ericorganic@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-forest-700' },
        { role: 'Homeowner (Maria Paula)', email: 'angarimp@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-slate-700' },
        { role: 'Homeowner (Steve)', email: 'oraresemper@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-slate-700' },
    ];
};

/**
 * Tier switcher credentials - used in PortalLayout for admin quick-switch.
 * Only available in non-production environments.
 */
export const getTierSwitchCredentials = () => {
    if (process.env.REACT_APP_ENV === 'production') {
        return [];
    }
    return [
        { role: 'admin', label: 'Administrator', email: 'phil.f.villard@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-amber-700 bg-amber-50 border-amber-200 hover:bg-amber-100' },
        { role: 'management', label: 'Management', email: 'prestigerem@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-forest-700 bg-forest-50 border-forest-200 hover:bg-forest-100' },
        { role: 'board', label: 'Board Member', email: 'rcn693@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-forest-700 bg-forest-50 border-forest-200 hover:bg-forest-100' },
        { role: 'member', label: 'Homeowner', email: 'angarimp@gmail.com', password: 'REPLACE_WITH_LOCAL_PASSWORD', color: 'text-slate-700 bg-slate-50 border-slate-200 hover:bg-slate-100' },
    ];
};
